import { register } from "@rill/loader";

/**
 * Registers the loader for program metrics data for the main graph.
 * This includes general usage metrics for all the programs in a certain time frame.
 */
register(
  {
    name: "programMetrics",
  },

  async ({ api, locals }, { dateFrom }) => {
    try {
      const { activeUser, activeUserToRequest } = locals;
      const programsOwnerId = activeUser?.organizationId
        ? activeUser?._id
        : activeUserToRequest?._id;

      const query = {
        isPush: true,
        actionTypes: JSON.stringify(["added-calendar-program"]),
        metadata: { programCoachOwner: programsOwnerId },
        dateFrom,
      };

      const res = await api("program-metrics", { query });
      const data = await res.json();

      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

/**
 * Registers the loader for program metrics data for the aside graph.
 * This includes usage metrics for a specific program in a certain time frame.
 */
register(
  {
    name: "selectedProgramMetrics",
  },

  async ({ api, locals }, { dateFrom, selectedProgramId }) => {
    try {
      const { activeUser, activeUserToRequest } = locals;
      const programsOwnerId = activeUser?.organizationId
        ? activeUser?._id
        : activeUserToRequest?._id;

      const query = {
        isPush: true,
        actionTypes: JSON.stringify(["added-calendar-program"]),
        metadata: {
          programCoachOwner: programsOwnerId,
          programId: selectedProgramId,
        },
        dateFrom,
      };

      const res = await api("program-metrics", { query });
      const data = await res.json();

      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

/**
 * Registers the loader for program metrics feed data.
 * This includes activity feed data for programs in a certain time frame.
 */
register(
  {
    name: "programMetricsFeed",
  },

  async ({ api, locals }, { pagination, limit, sort }) => {
    try {
      const { activeUser, activeUserToRequest } = locals;
      const programsOwnerId = activeUser?.organizationId
        ? activeUser?._id
        : activeUserToRequest?._id;

      const query = {
        isPush: true,
        actionTypes: JSON.stringify(["added-calendar-program"]),
        metadata: { programCoachOwner: programsOwnerId },
        pagination,
        limit,
        sort,
        forFeed: true,
      };

      const res = await api("program-metrics", { query });
      const data = await res.json();

      return data;
    } catch (error) {
      console.error(error);
    }
  }
);
